import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface LiveKitTokenResponse {
    token: string;
    livekit_host_url: string;
}

@Injectable({
    providedIn: 'root'
})
export class AiChatWidgetService {
    private backendApiBase = environment.baseUrl;
    private bearerToken = environment.bearerToken;

    constructor(private http: HttpClient) { }

    /**
     * Get LiveKit token from secure backend endpoint.
     * This endpoint handles all credential management server-side.
     * 
     * @param agentId - The agent ID to connect to
     * @returns Observable with token and host URL
     */
    getLiveKitToken(agentId: string): Observable<LiveKitTokenResponse> {
        const url = `${this.backendApiBase}v1/livekit/generate-token`;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.bearerToken}`
        });

        const body = {
            agent_id: agentId
        };

        return this.http.post<LiveKitTokenResponse>(url, body, { headers });
    }
}
